
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { TableDownstreamMetricsQueryVariables, TableDownstreamMetricsQuery, MetricsDisplayGridRowDataFragment, TableDownstreamMetricsFilteredByColumnQueryVariables, TableDownstreamMetricsFilteredByColumnQuery, MetricSortOrder , TableDownstreamMetricsFilteredByColumnDocument , TableDownstreamMetricsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
} from '../../../data-catalog-shared';
import { getRowDataForMetric, MetricsDisplayGrid, MetricsDisplayGridRowData } from '../sharedDisplayGrid/MetricsDisplayGrid';
import { MetricsValidSortFields } from '../sorting/sortProviders/MetricsGridSortProvider';

type QueryVariables = TableDownstreamMetricsQueryVariables;
type QueryResults = TableDownstreamMetricsQuery;
type QueryResultListNode = MetricsDisplayGridRowDataFragment;
type GridRowData = MetricsDisplayGridRowData;

type QueryVariablesWithFilter = TableDownstreamMetricsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = TableDownstreamMetricsFilteredByColumnQuery;
type QueryResultListNodeWithFilter = MetricsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.tables && resultData.tables[0] &&
    resultData.tables[0].downstreamMetricsConnection;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  return resultData && resultData.columns && resultData.columns[0] &&
    resultData.columns[0].downstreamMetricsConnection;
}

export type TableDownstreamMetricsQueryGridProps =
  GridSortProps<MetricsValidSortFields> & {
    readonly tableId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function TableDownstreamMetricsQueryGrid(props: TableDownstreamMetricsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamMetricsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredMetricsLineageGridMessage();

  return (
    props.filteredColumnId ? (
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
        queryGql={TableDownstreamMetricsFilteredByColumnDocument}
        partialQueryVariables={{ columnId: props.filteredColumnId, orderBy: props.orderBy as MetricSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={TableDownstreamMetricsDocument}
        partialQueryVariables={{ tableId: props.tableId, orderBy: props.orderBy as MetricSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
